
export const shouldShowMobileMode = true;
export const shouldShowMobileModeSSR = true;

export const mobileModeWidth = 600;

export const mobileModeMaxWidthClassName = 'max-w-' + mobileModeWidth;
